import Vue from "vue";
import * as MUTATIONS from "../config/constants/mutation-types";

export default {
  /**
   * Mutation llamada por el router
   * Ponemos la ruta en el state
   * @param {Object} state
   * @param {Object} payload
   */
  [MUTATIONS.ON_ROUTE]: (state, payload) => {
    Vue.set(state, "route", payload);
  },
  /**
   * Mostrar u ocultar el loader
   * @param {Object} context
   * @param {Boolean} payload estado
   */
  [MUTATIONS.ON_IS_LOADING]: (state, payload) => {
    Vue.set(state, "isLoading", !!payload);
  },
  /**
   * Mutation disparadas por el
   * step navigator para avanzar pasos
   * Cada action guarda el paso
   * actual en el store
   * @param {Object} state
   */
  [MUTATIONS.ON_LANDING]: (state, payload) => {
    Vue.set(state, "landing", payload);
  },
  [MUTATIONS.ON_PASO_1]: (state, payload) => {
    Vue.set(state, "paso1", payload);
  },
  [MUTATIONS.ON_PASO_2]: (state, payload) => {
    Vue.set(state, "paso2", payload);
  },
  [MUTATIONS.ON_CONFIRMACION]: (state, payload) => {
    Vue.set(state, "responseConfirmacion", payload);
  },
  [MUTATIONS.ON_GRACIAS]: (state, payload) => {
    Vue.set(state, "gracias", payload);
  },
  [MUTATIONS.ON_MOCK]: (state, payload) => {
    Vue.set(state, "mock", payload);
  },
  [MUTATIONS.ON_DATOS_PERSONALES]: (state, payload) => {
    Vue.set(state, "datosPersonales", payload);
  },
  [MUTATIONS.ON_DATOS_SUCURSAL]: (state, payload) => {
    Vue.set(state, "datosSucursal", payload);
  },
  [MUTATIONS.ON_TIPOS_TRAMITE]: (state, payload) => {
    Vue.set(state, "tiposTramite", payload);
  },
  [MUTATIONS.ON_FECHA_TURNO]: (state, payload) => {
    Vue.set(state, "fechaTurno", payload);
  },
  [MUTATIONS.ON_HORA_TURNO]: (state, payload) => {
    Vue.set(state, "horaTurno", payload);
  },
  [MUTATIONS.ON_FECHA_TURNO_HORADEFAULT]: (state, payload) => {
    Vue.set(state.fechaTurno, "horaSeleccionada", payload);
  },
  [MUTATIONS.ON_TURNO_AGENDADO]: (state, payload) => {
    Vue.set(state, "turnoAgendado", payload);
  },
  [MUTATIONS.ON_GRACIAS_PERSONAS]: (state, payload) => {
    Vue.set(state, "graciasPersonas", payload);
  },
  [MUTATIONS.ON_SUCURSALES]: (state, payload) => {
    Vue.set(state, "sucursales", payload);
  }
};
